import { render } from "./editUserPopup.vue?vue&type=template&id=4d5dd066&scoped=true"
import script from "./editUserPopup.vue?vue&type=script&lang=js"
export * from "./editUserPopup.vue?vue&type=script&lang=js"

import "./editUserPopup.vue?vue&type=style&index=0&id=4d5dd066&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5dd066"]])

export default __exports__